// import React from 'react';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend } from 'recharts';
// import { monthlyData } from '../data/mockData';

// const Overview = () => (
//   <div>
//     <h2>Overview</h2>
//     <BarChart width={500} height={300} data={monthlyData}>
//       <XAxis dataKey="name" />
//       <YAxis />
//       <Tooltip />
//       <Legend />
//       <Bar dataKey="count" fill="#8884d8" />
//     </BarChart>
//   </div>
// );

// export default Overview;

import React from 'react';
import {
  LineChart, Line,
  BarChart, Bar,
  PieChart, Pie,
  XAxis, YAxis,
  CartesianGrid, Tooltip, Legend,
  ResponsiveContainer, Cell, RadarChart, Radar, PolarGrid, PolarAngleAxis, PolarRadiusAxis
} from 'recharts';

import {
  monthlyData,
  demographicsData,
  scamTypesData,
  controlData,
  COLORS
} from '../data/mockData';

const Overview = () => {
  return (
    <div className="space-y-6">
      
      {/* Summary Boxes
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-white p-4 rounded shadow">
          <h3 className="text-sm font-medium text-gray-500">Total VOTs Identified</h3>
          <p className="text-2xl font-bold">317</p>
          <p className="text-xs text-green-600">↑ 12% from last year</p>
        </div>
        <div className="bg-white p-4 rounded shadow">
          <h3 className="text-sm font-medium text-gray-500">Average Age</h3>
          <p className="text-2xl font-bold">29.4</p>
          <p className="text-xs text-gray-500">Years old</p>
        </div>
        <div className="bg-white p-4 rounded shadow">
          <h3 className="text-sm font-medium text-gray-500">Avg. Exploitation Duration</h3>
          <p className="text-2xl font-bold">8.5</p>
          <p className="text-xs text-gray-500">Months</p>
        </div>
        <div className="bg-white p-4 rounded shadow">
          <h3 className="text-sm font-medium text-gray-500">Avg. Ransom Demanded</h3>
          <p className="text-2xl font-bold">$3,200</p>
          <p className="text-xs text-red-600">↑ 15% from last year</p>
        </div>
      </div> */}

      {/* Summary Metrics (Styled as Cards) */}
        <div className="space-y-4">
        <div className="bg-white rounded-lg shadow-sm p-6">
            <h3 className="text-sm font-medium text-gray-500">Total VOTs Identified</h3>
            <p className="text-3xl font-bold text-gray-900 mt-1">317</p>
            <p className="text-sm text-green-600 mt-1">↑ 12% from previous year</p>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6">
            <h3 className="text-sm font-medium text-gray-500">Average Age</h3>
            <p className="text-3xl font-bold text-gray-900 mt-1">29.4</p>
            <p className="text-sm text-gray-500 mt-1">Years old</p>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6">
            <h3 className="text-sm font-medium text-gray-500">Average Exploitation Duration</h3>
            <p className="text-3xl font-bold text-gray-900 mt-1">8.5</p>
            <p className="text-sm text-gray-500 mt-1">Months</p>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6">
            <h3 className="text-sm font-medium text-gray-500">Average Ransom Amount</h3>
            <p className="text-3xl font-bold text-gray-900 mt-1">$3,200</p>
            <p className="text-sm text-red-600 mt-1">↑ 15% from previous year</p>
        </div>
        </div>

      {/* Monthly Trends and Gender */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Monthly Line Chart */}
        <div className="bg-white p-4 rounded shadow">
          <h3 className="font-semibold mb-2">Monthly VOT Cases</h3>
          <div style={{ width: '100%', height: 300 }}>
            <ResponsiveContainer>
              <LineChart data={monthlyData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="count" stroke="#8884d8" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Gender Pie Chart */}
        <div className="bg-white p-4 rounded shadow">
          <h3 className="font-semibold mb-2">Gender Distribution</h3>
          <div style={{ width: '100%', height: 300 }}>
            <ResponsiveContainer>
              <PieChart>
                <Pie
                  data={demographicsData}
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  dataKey="value"
                  label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                >
                  {demographicsData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Control Mechanisms and Scam Types */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Control Bar */}
        <div className="bg-white p-4 rounded shadow">
          <h3 className="font-semibold mb-2">Top Control Mechanisms</h3>
          <div style={{ width: '100%', height: 300 }}>
            <ResponsiveContainer>
              <BarChart layout="vertical" data={controlData.slice(0, 5)}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="number" />
                <YAxis type="category" dataKey="name" />
                <Tooltip />
                <Bar dataKey="value" fill="#FF8042">
                  {controlData.slice(0, 5).map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Scam Types Radar */}
        <div className="bg-white p-4 rounded shadow">
          <h3 className="font-semibold mb-2">Types of Scams</h3>
          <div style={{ width: '100%', height: 300 }}>
            <ResponsiveContainer>
            <RadarChart data={scamTypesData} cx="50%" cy="50%" outerRadius="80%">
                <PolarGrid />
                    <PolarAngleAxis dataKey="name" />
                <PolarRadiusAxis />
                    <Radar name="Scam Type" dataKey="value" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />
                <Tooltip />
            </RadarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;